export const WELCOME_MESSAGE = 'Keyman Letterへようこそ！';
export const SAVE_SUCCESS = '保存しました。';
export const DELETE_SUCCESS = '削除しました。';
export const DELETING = '削除しています…';
export const POST_SUCCESS = '登録しました。';
export const POST_ADDRESS_SUCCESS = 'アドレス帳に登録しました。';
export const ORDER_RECEIVED = 'ご注文を受け付けました。印刷〜配送完了まで2〜3日かかります。';
export const ADDRESS_UNSAVED = '入力が完了していません。\nこのページから移動してもよろしいですか？';
export const APPLY_SAAS_KEY_SUCCESS = 'プロダクトキーを適用しました。';
export const DELETE_NG_SENDINGS_SUCCESS = "送付NGを解除しました。";
export const POST_ADDRESSES_MOVE_NG_SENDINGS_SUCCESS = "移動しました。";
export const POST_ADDRESSES_RESTORE_NG_SENDINGS_SUCCESS = "取り消しました。";
export const DELETING_TAG = "除去しています…";
export const DELETE_TAG_SUCCESS = "除去しました。";
export const ADD_TAG_SUCCESS = "追加しました。";
export const VERIFY_SUCCESS = "照合しました。";
export const UPDATE_SUCCESS = "更新しました。";
export const CHANGE_SUCCESS = "変更しました。";
export const REVOKE_SUCCESS = "連携を解除しました。";



// WEBPACK FOOTER //
// ./src/constants/Messages.js